// Mock data for the Base2Brand AI Sales OS demo

export const JOBS = [
  {
    id: "job-001",
    source: "Upwork",
    title: "Shopify Plus Migration + Custom Checkout",
    client: "Nova Athletics",
    country: "United States",
    budget: "$18,000 fixed",
    type: "Fixed",
    match: 96,
    winProb: 74,
    verified: true,
    spent: "$412k",
    hires: 38,
    postedAgo: "12m",
    tags: ["Shopify", "Headless", "Checkout"],
    summary:
      "Migrating our current Shopify store to Shopify Plus with a fully customized checkout, GA4 + server-side tagging and a headless PDP.",
  },
  {
    id: "job-002",
    source: "LinkedIn",
    title: "AI Chatbot for B2B SaaS onboarding",
    client: "Kestrel Analytics",
    country: "United Kingdom",
    budget: "$85/hr",
    type: "Hourly",
    match: 91,
    winProb: 62,
    verified: true,
    spent: "$220k",
    hires: 14,
    postedAgo: "48m",
    tags: ["OpenAI", "React", "n8n"],
    summary:
      "Need an AI copilot embedded in onboarding — should read our KB and answer usage questions.",
  },
  {
    id: "job-003",
    source: "Upwork",
    title: "ERP integration — NetSuite ↔ Shopify",
    client: "Belvedere Wines",
    country: "Canada",
    budget: "$32,000 fixed",
    type: "Fixed",
    match: 88,
    winProb: 55,
    verified: true,
    spent: "$610k",
    hires: 51,
    postedAgo: "2h",
    tags: ["NetSuite", "ERP", "Shopify"],
    summary:
      "Bi-directional inventory + order sync between NetSuite and Shopify, plus a fulfilment dashboard.",
  },
  {
    id: "job-004",
    source: "Upwork",
    title: "Cross-platform mobile app (React Native)",
    client: "Halcyon Health",
    country: "Australia",
    budget: "$45,000 fixed",
    type: "Fixed",
    match: 84,
    winProb: 48,
    verified: false,
    spent: "$18k",
    hires: 3,
    postedAgo: "3h",
    tags: ["React Native", "HIPAA", "Auth"],
    summary:
      "Patient engagement app with secure messaging, appointment booking and Fitbit integration.",
  },
  {
    id: "job-005",
    source: "LinkedIn",
    title: "SEO overhaul for high-traffic marketplace",
    client: "Fern & Field",
    country: "Germany",
    budget: "$6,500/mo retainer",
    type: "Retainer",
    match: 79,
    winProb: 40,
    verified: true,
    spent: "$95k",
    hires: 22,
    postedAgo: "5h",
    tags: ["SEO", "Technical SEO", "Contentful"],
    summary:
      "180k SKUs, need site-wide technical SEO overhaul, faceted nav strategy and content ops.",
  },
  {
    id: "job-006",
    source: "Upwork",
    title: "UI/UX audit for fintech dashboard",
    client: "Torrent Payments",
    country: "Singapore",
    budget: "$8,500 fixed",
    type: "Fixed",
    match: 77,
    winProb: 44,
    verified: true,
    spent: "$140k",
    hires: 18,
    postedAgo: "6h",
    tags: ["UI/UX", "Fintech", "Figma"],
    summary:
      "Audit our merchant dashboard, deliver a redesign roadmap and a component library brief.",
  },
];

export const RFPS = [
  {
    id: "rfp-001",
    title: "Statewide K-12 LMS Modernization",
    agency: "Texas Education Agency",
    category: "Education",
    budget: "$2.4M",
    closes: "2026-03-14",
    daysLeft: 22,
    score: 92,
    docs: 6,
    status: "Qualified",
    certs: ["ISO 27001", "SOC 2 Type II"],
  },
  {
    id: "rfp-002",
    title: "Municipal Water Utility CRM & Billing",
    agency: "City of Portland",
    category: "Utilities",
    budget: "$860K",
    closes: "2026-02-28",
    daysLeft: 9,
    score: 88,
    docs: 4,
    status: "Drafting",
    certs: ["NIST 800-53"],
  },
  {
    id: "rfp-003",
    title: "Rural Broadband Deployment Portal",
    agency: "USDA Rural Utilities Service",
    category: "Federal",
    budget: "$5.1M",
    closes: "2026-04-02",
    daysLeft: 41,
    score: 84,
    docs: 11,
    status: "Reviewing",
    certs: ["FedRAMP Moderate"],
  },
  {
    id: "rfp-004",
    title: "Transit Fare System Overhaul",
    agency: "Bay Area Rapid Transit",
    category: "Transportation",
    budget: "$3.8M",
    closes: "2026-03-05",
    daysLeft: 13,
    score: 76,
    docs: 7,
    status: "Qualified",
    certs: ["PCI-DSS L1"],
  },
  {
    id: "rfp-005",
    title: "County Health Records Interop Platform",
    agency: "Cook County Health",
    category: "Healthcare",
    budget: "$1.6M",
    closes: "2026-02-21",
    daysLeft: 2,
    score: 71,
    docs: 5,
    status: "Closing Soon",
    certs: ["HIPAA", "HITRUST"],
  },
  {
    id: "rfp-006",
    title: "Airport Wayfinding & Digital Signage",
    agency: "Denver Int'l Airport",
    category: "Transportation",
    budget: "$720K",
    closes: "2026-03-22",
    daysLeft: 30,
    score: 69,
    docs: 3,
    status: "Reviewing",
    certs: [],
  },
];

export const MAPS_BUSINESSES = [
  {
    id: "biz-001",
    name: "Willow & Oak Café",
    category: "Café",
    rating: 4.6,
    reviews: 428,
    city: "Austin, TX",
    website: "willowoakcafe.com",
    phone: "+1 (512) 555-0119",
    email: "hello@willowoakcafe.com",
    audit: 42,
    opportunity: 88,
    issues: ["Slow site", "No booking", "Weak SEO"],
    x: 24,
    y: 32,
  },
  {
    id: "biz-002",
    name: "Meridian Auto Detail",
    category: "Auto services",
    rating: 4.9,
    reviews: 612,
    city: "Austin, TX",
    website: "meridiandetail.co",
    phone: "+1 (512) 555-0177",
    email: "book@meridiandetail.co",
    audit: 61,
    opportunity: 74,
    issues: ["No online booking", "Missing eCommerce"],
    x: 62,
    y: 22,
  },
  {
    id: "biz-003",
    name: "Bluewater Dental",
    category: "Dentist",
    rating: 4.7,
    reviews: 289,
    city: "Austin, TX",
    website: "bluewaterdental.com",
    phone: "+1 (512) 555-0143",
    email: "office@bluewaterdental.com",
    audit: 38,
    opportunity: 91,
    issues: ["Not mobile-friendly", "No AI chat", "Slow load"],
    x: 48,
    y: 62,
  },
  {
    id: "biz-004",
    name: "Ridgeline Roofers",
    category: "Contractor",
    rating: 4.4,
    reviews: 156,
    city: "Round Rock, TX",
    website: "ridgelineroof.com",
    phone: "+1 (512) 555-0198",
    email: "quote@ridgelineroof.com",
    audit: 51,
    opportunity: 82,
    issues: ["Weak branding", "No lead form"],
    x: 78,
    y: 48,
  },
  {
    id: "biz-005",
    name: "Sage & Stone Yoga",
    category: "Wellness",
    rating: 4.8,
    reviews: 341,
    city: "Austin, TX",
    website: "sageandstoneyoga.com",
    phone: "+1 (512) 555-0166",
    email: "namaste@sageandstoneyoga.com",
    audit: 57,
    opportunity: 69,
    issues: ["No class booking", "Missing schema"],
    x: 34,
    y: 74,
  },
  {
    id: "biz-006",
    name: "North Loop Brewing",
    category: "Brewery",
    rating: 4.5,
    reviews: 894,
    city: "Austin, TX",
    website: "northloopbrew.com",
    phone: "+1 (512) 555-0122",
    email: "events@northloopbrew.com",
    audit: 46,
    opportunity: 77,
    issues: ["Outdated design", "No events page"],
    x: 68,
    y: 78,
  },
];

export const LINKEDIN_PROSPECTS = [
  {
    id: "li-001",
    name: "Sarah Chen",
    title: "VP of Engineering",
    company: "Kestrel Analytics",
    industry: "SaaS",
    employees: "120",
    growth: "+34% YoY",
    score: 94,
    connected: false,
    tech: ["React", "AWS", "Snowflake"],
  },
  {
    id: "li-002",
    name: "Marcus Alvarez",
    title: "Head of Digital",
    company: "Belvedere Wines",
    industry: "eCommerce",
    employees: "45",
    growth: "+18% YoY",
    score: 89,
    connected: true,
    tech: ["Shopify Plus", "Klaviyo"],
  },
  {
    id: "li-003",
    name: "Priya Nair",
    title: "CTO",
    company: "Halcyon Health",
    industry: "HealthTech",
    employees: "60",
    growth: "+52% YoY",
    score: 86,
    connected: false,
    tech: ["React Native", "GCP", "FHIR"],
  },
  {
    id: "li-004",
    name: "Devon Reilly",
    title: "CEO",
    company: "Nova Athletics",
    industry: "DTC",
    employees: "25",
    growth: "+112% YoY",
    score: 92,
    connected: false,
    tech: ["Shopify", "Meta Ads"],
  },
];

export const INSTAGRAM_PROSPECTS = [
  {
    id: "ig-001",
    handle: "@sageandstoneyoga",
    followers: "48.2k",
    engagement: "4.8%",
    city: "Austin, TX",
    website: "sageandstoneyoga.com",
    email: "namaste@sageandstoneyoga.com",
    branding: 71,
  },
  {
    id: "ig-002",
    handle: "@northloopbrew",
    followers: "22.7k",
    engagement: "3.2%",
    city: "Austin, TX",
    website: "northloopbrew.com",
    email: "events@northloopbrew.com",
    branding: 64,
  },
  {
    id: "ig-003",
    handle: "@willowoakcafe",
    followers: "17.5k",
    engagement: "6.1%",
    city: "Austin, TX",
    website: "willowoakcafe.com",
    email: "hello@willowoakcafe.com",
    branding: 58,
  },
  {
    id: "ig-004",
    handle: "@meridiandetail",
    followers: "9.8k",
    engagement: "5.4%",
    city: "Austin, TX",
    website: "meridiandetail.co",
    email: "book@meridiandetail.co",
    branding: 62,
  },
];

export const PIPELINE_STAGES = [
  { key: "new", label: "New Lead", color: "#5E6AD2" },
  { key: "qualified", label: "Qualified", color: "#00E5FF" },
  { key: "contacted", label: "Contacted", color: "#8B5CF6" },
  { key: "discovery", label: "Discovery Call", color: "#F59E0B" },
  { key: "proposal", label: "Proposal Sent", color: "#EC4899" },
  { key: "negotiation", label: "Negotiation", color: "#F97316" },
  { key: "won", label: "Won", color: "#10B981" },
  { key: "lost", label: "Lost", color: "#71717A" },
];

export const CRM_LEADS = [
  { id: "l-1", company: "Nova Athletics", contact: "Devon Reilly", value: 42000, source: "Upwork", stage: "proposal", score: 92, updated: "2h" },
  { id: "l-2", company: "Kestrel Analytics", contact: "Sarah Chen", value: 68000, source: "LinkedIn", stage: "discovery", score: 94, updated: "4h" },
  { id: "l-3", company: "Belvedere Wines", contact: "Marcus Alvarez", value: 32000, source: "Upwork", stage: "qualified", score: 88, updated: "6h" },
  { id: "l-4", company: "Halcyon Health", contact: "Priya Nair", value: 45000, source: "LinkedIn", stage: "contacted", score: 86, updated: "1d" },
  { id: "l-5", company: "Fern & Field", contact: "Ana Weber", value: 78000, source: "LinkedIn", stage: "negotiation", score: 81, updated: "1d" },
  { id: "l-6", company: "Torrent Payments", contact: "Jae Park", value: 8500, source: "Upwork", stage: "new", score: 77, updated: "2d" },
  { id: "l-7", company: "Willow & Oak Café", contact: "Rosa Martín", value: 4200, source: "Maps", stage: "new", score: 62, updated: "3d" },
  { id: "l-8", company: "Bluewater Dental", contact: "Dr. K. Osei", value: 12000, source: "Maps", stage: "contacted", score: 74, updated: "3d" },
  { id: "l-9", company: "TXA Rural Broadband", contact: "P. Whitaker", value: 510000, source: "RFP", stage: "qualified", score: 84, updated: "5d" },
  { id: "l-10", company: "Cook County Health", contact: "L. Okonkwo", value: 160000, source: "RFP", stage: "proposal", score: 71, updated: "1w" },
  { id: "l-11", company: "Sage & Stone Yoga", contact: "M. Ito", value: 3600, source: "Instagram", stage: "won", score: 68, updated: "2w" },
  { id: "l-12", company: "Meridian Auto Detail", contact: "R. Salas", value: 5800, source: "Maps", stage: "lost", score: 55, updated: "3w" },
];

export const DASHBOARD_METRICS = {
  newJobsToday: 128,
  highValueJobs: 34,
  proposalWinRate: 32,
  estRevenue: 486000,
  aiMatch: 87,
  activeRFPs: 24,
  closingSoon: 5,
  businessesFound: 1284,
  newProspects: 96,
  meetingsBooked: 12,
};

export const REVENUE_TREND = [
  { m: "Sep", v: 210 },
  { m: "Oct", v: 265 },
  { m: "Nov", v: 298 },
  { m: "Dec", v: 342 },
  { m: "Jan", v: 401 },
  { m: "Feb", v: 486 },
];

export const SOURCE_MIX = [
  { name: "Upwork", value: 34, color: "#5E6AD2" },
  { name: "LinkedIn", value: 26, color: "#00E5FF" },
  { name: "RFP", value: 18, color: "#F59E0B" },
  { name: "Maps", value: 14, color: "#10B981" },
  { name: "Instagram", value: 8, color: "#EC4899" },
];

export const WORKFLOW_NODES = [
  { id: "n1", label: "Lead Source", sub: "Apollo · 240 leads", x: 40,  y: 60, kind: "source", color: "#5E6AD2" },
  { id: "n2", label: "Website Analysis", sub: "Lighthouse + AI", x: 260, y: 60, kind: "ai",     color: "#00E5FF" },
  { id: "n3", label: "Email Finder", sub: "Hunter.io", x: 480, y: 60, kind: "tool", color: "#8B5CF6" },
  { id: "n4", label: "AI Company Research", sub: "Claude Sonnet", x: 700, y: 60, kind: "ai", color: "#00E5FF" },
  { id: "n5", label: "Personalized Email", sub: "GPT-5.2 + brand voice", x: 260, y: 220, kind: "ai", color: "#00E5FF" },
  { id: "n6", label: "CRM", sub: "Sync + score", x: 480, y: 220, kind: "sink", color: "#10B981" },
  { id: "n7", label: "Follow-up Sequence", sub: "3-step · 6d", x: 700, y: 220, kind: "action", color: "#F59E0B" },
  { id: "n8", label: "Meeting Booking", sub: "Calendly", x: 920, y: 220, kind: "action", color: "#EC4899" },
];

export const WORKFLOW_EDGES = [
  { from: "n1", to: "n2" },
  { from: "n2", to: "n3" },
  { from: "n3", to: "n4" },
  { from: "n4", to: "n5" },
  { from: "n5", to: "n6" },
  { from: "n6", to: "n7" },
  { from: "n7", to: "n8" },
];

export const RECENT_ACTIVITY = [
  { id: "a1", who: "AI Copilot", what: "Generated 4 proposals for Shopify jobs", when: "3m ago", tone: "ai" },
  { id: "a2", who: "n8n · Outreach", what: "Sent 128 personalized emails", when: "22m ago", tone: "flow" },
  { id: "a3", who: "RFP Watcher", what: "3 new federal RFPs matched profile", when: "1h ago", tone: "rfp" },
  { id: "a4", who: "Maps Finder", what: "Discovered 84 new Austin businesses", when: "2h ago", tone: "maps" },
  { id: "a5", who: "LinkedIn Bot", what: "Sent 42 connection requests", when: "4h ago", tone: "social" },
];

// ---------------------------------------------------------------------------
// Module 6 — Website Lead Intelligence
// ---------------------------------------------------------------------------
export const WEBSITE_VISITORS_LIVE = [
  { id: "v1", company: "Aurora Health Systems", city: "Boston, MA",   pages: 6, current: "/services/ai",       source: "google/organic", enriched: true },
  { id: "v2", company: "Northwind Trading Co.", city: "London, UK",   pages: 3, current: "/case-studies/shopify", source: "linkedin/paid", enriched: true },
  { id: "v3", company: "Pixel Foundry",         city: "Toronto, CA",  pages: 9, current: "/pricing",           source: "direct",         enriched: true },
  { id: "v4", company: "Sundeep Labs",          city: "Bengaluru, IN", pages: 2, current: "/blog/erp",         source: "twitter",        enriched: false },
  { id: "v5", company: "Meridian Freight",      city: "Chicago, IL",  pages: 4, current: "/contact",           source: "google/organic", enriched: true },
];

export const WEBSITE_LEADS = [
  {
    id: "wl-1", name: "Erica Whitman", email: "erica@auroracare.com", company: "Aurora Health Systems",
    service: "AI Chatbot", form: "Service Inquiry", landing: "/services/ai", source: "google/organic",
    score: 91, quality: "High", when: "2m ago", notes: "Wants AI intake bot for 4 clinics",
  },
  {
    id: "wl-2", name: "Jonas Bell", email: "jonas@northwind.co.uk", company: "Northwind Trading Co.",
    service: "Shopify Plus", form: "Quote Request", landing: "/case-studies/shopify", source: "linkedin/paid",
    score: 88, quality: "High", when: "18m ago", notes: "Migrating from Magento 2 — budget £45k",
  },
  {
    id: "wl-3", name: "Amelia Ortiz", email: "amelia@pixelfoundry.io", company: "Pixel Foundry",
    service: "UI/UX", form: "Contact Form", landing: "/pricing", source: "direct",
    score: 74, quality: "Med", when: "1h ago", notes: "Design system audit for design agency",
  },
  {
    id: "wl-4", name: "Rahul Menon", email: "rahul@sundeep.io", company: "Sundeep Labs",
    service: "ERP", form: "Chat Widget", landing: "/blog/erp", source: "twitter",
    score: 62, quality: "Med", when: "3h ago", notes: "Small SaaS considering NetSuite alt",
  },
  {
    id: "wl-5", name: "Mark Doyle", email: "mark@meridianfreight.com", company: "Meridian Freight",
    service: "Mobile App", form: "Newsletter", landing: "/", source: "google/organic",
    score: 41, quality: "Low", when: "5h ago", notes: "Newsletter opt-in, no clear intent yet",
  },
];

export const WEBSITE_TOP_PAGES = [
  { page: "/services/ai",       views: 4820, conv: 6.4 },
  { page: "/case-studies/shopify", views: 3210, conv: 5.1 },
  { page: "/pricing",           views: 2870, conv: 4.8 },
  { page: "/services/erp",      views: 1940, conv: 3.9 },
  { page: "/blog/erp",          views: 1620, conv: 2.4 },
];

export const WEBSITE_SERVICES_REQUESTED = [
  { name: "AI",       value: 32, color: "#5E6AD2" },
  { name: "Shopify",  value: 24, color: "#00E5FF" },
  { name: "ERP",      value: 18, color: "#F59E0B" },
  { name: "Mobile",   value: 14, color: "#EC4899" },
  { name: "SEO",      value: 12, color: "#10B981" },
];

export const WEBSITE_JOURNEY = [
  { t: "0s",    ev: "Landed on /case-studies/shopify",   type: "page" },
  { t: "48s",   ev: "Scrolled 82% of case study",         type: "engage" },
  { t: "1m32s", ev: "Clicked /services/shopify-plus",    type: "page" },
  { t: "2m10s", ev: "Opened pricing page",                type: "page" },
  { t: "3m24s", ev: "Started chat with AI assistant",     type: "chat" },
  { t: "4m11s", ev: "Submitted Quote Request form",       type: "convert" },
];

// ---------------------------------------------------------------------------
// Module 7 — Email Lead Intelligence
// ---------------------------------------------------------------------------
export const EMAIL_LEADS = [
  {
    id: "e-1", from: "Naomi Park", email: "naomi@lattice-labs.com", company: "Lattice Labs",
    subject: "Enterprise AI copilot — pricing + timeline",
    intent: "Sales Inquiry", urgency: "High", sentiment: "Positive",
    when: "8m ago", unread: true, attachments: ["RFP-brief.pdf"],
    summary: "Series C fintech seeking an enterprise AI copilot with SSO. Budget mentioned: $180k. Wants pricing by Friday.",
    body: "Hi team, we've followed your work on the Kestrel deployment. We're evaluating an internal AI copilot for our compliance team — 300 seats — and would love a call this week to discuss pricing, SSO integration and timeline. Attached is our brief. Thanks, Naomi",
    priority: 96,
    suggestedReply: "Hi Naomi — thanks for the note. Compliance-grade copilots are a strength of ours; we've delivered a similar rollout for a Series C fintech last quarter. Would 45 min this Thursday 2pm ET work? I'll send a Calendly link.",
  },
  {
    id: "e-2", from: "James Corben", email: "james@corben.gov.uk", company: "UK Cabinet Office",
    subject: "RFP — Digital identity onboarding platform",
    intent: "RFP",          urgency: "High", sentiment: "Neutral",
    when: "1h ago", unread: true, attachments: ["RFP-2026-0148.pdf", "Annex-A.pdf"],
    summary: "Formal RFP for UK Digital Identity onboarding. Deadline in 21 days. Budget bracket £800k–£1.2M.",
    body: "Please find attached RFP-2026-0148. Bids must be submitted via the Contracts Finder portal. All questions to be routed through the procurement inbox. Kind regards, James",
    priority: 91,
    suggestedReply: "James — acknowledged. We'll confirm intent to bid within 48 hours and submit clarifying questions ahead of the Q&A window. Regards, Base2Brand Bids Team",
  },
  {
    id: "e-3", from: "Sophie Al-Rashid", email: "sophie@bluebird.co", company: "Bluebird Studios",
    subject: "Partnership — creative + engineering",
    intent: "Partnership", urgency: "Med", sentiment: "Positive",
    when: "3h ago", unread: false, attachments: [],
    summary: "Creative agency looking for an engineering partner to co-deliver DTC builds. Open to referral model.",
    body: "Hi — we love your work. We're a boutique creative studio and would love to explore a partnership where we hand off the engineering side to a trusted team. Any interest?",
    priority: 74,
    suggestedReply: "Sophie — absolutely, this is a model we run with 3 other agencies. Happy to share our partner deck. Grab a slot: calendly.com/base2brand/partners",
  },
  {
    id: "e-4", from: "Devon Reilly", email: "devon@novaathletics.com", company: "Nova Athletics",
    subject: "Re: Shopify Plus migration — timeline",
    intent: "Existing Deal", urgency: "Med", sentiment: "Positive",
    when: "5h ago", unread: false, attachments: [],
    summary: "Existing pipeline (Proposal Sent). Requesting revised timeline for Q2 launch.",
    body: "Team — thanks for the call. Can we get a revised timeline with a launch pinned to April 2nd? — Devon",
    priority: 82,
    suggestedReply: "Devon — updating the plan to a firm Apr 2 launch. We'll circulate a revised Gantt today by 5pm ET.",
  },
  {
    id: "e-5", from: "Priya Nair", email: "priya@halcyon.health", company: "Halcyon Health",
    subject: "Question about HIPAA in your React Native stack",
    intent: "Sales Inquiry", urgency: "Med", sentiment: "Neutral",
    when: "1d ago", unread: false, attachments: [],
    summary: "Pre-sales technical question re: HIPAA-compliant messaging on React Native.",
    body: "Do you use MessageKit or a custom TLS wrapper for HIPAA-compliant messaging on RN?",
    priority: 68,
    suggestedReply: "Priya — we use a custom TLS pipeline plus SQLCipher on-device. Happy to walk through it — 20 min call this week?",
  },
  {
    id: "e-6", from: "Steve Cormier", email: "steve@cormierlaw.com", company: "Cormier & Partners",
    subject: "Newsletter subscription confirmation",
    intent: "Newsletter",  urgency: "Low", sentiment: "Neutral",
    when: "1d ago", unread: false, attachments: [],
    summary: "Newsletter opt-in. No sales intent detected.",
    body: "Please confirm my subscription.",
    priority: 22,
    suggestedReply: "Subscription confirmed. Welcome!",
  },
];

// ---------------------------------------------------------------------------
// Module 8 — Meeting Booking Intelligence
// ---------------------------------------------------------------------------
export const MEETINGS = [
  {
    id: "m-1", when: "Today · 14:00", duration: "45 min", channel: "Google Meet",
    prospect: "Naomi Park", role: "VP Product", company: "Lattice Labs",
    source: "Calendly · /services/ai", status: "Confirmed",
    prep: "Series C fintech, 300-seat compliance copilot. Prepare SOC 2 talking points + reference architecture. Budget ~$180k.",
    agenda: ["Intros & context (5m)", "Compliance & SSO deep-dive (15m)", "Reference architecture (10m)", "Pricing & timeline (10m)", "Next steps (5m)"],
    history: 3, quality: 94,
  },
  {
    id: "m-2", when: "Today · 16:30", duration: "30 min", channel: "Zoom",
    prospect: "Marcus Alvarez", role: "Head of Digital", company: "Belvedere Wines",
    source: "Website booking widget", status: "Confirmed",
    prep: "Existing deal in Qualified. Needs a NetSuite ↔ Shopify architecture diagram.",
    agenda: ["Recap of last call (5m)", "Architecture walkthrough (15m)", "Statement of Work review (10m)"],
    history: 5, quality: 88,
  },
  {
    id: "m-3", when: "Tomorrow · 10:00", duration: "60 min", channel: "In-person · London",
    prospect: "James Corben", role: "Digital Lead", company: "UK Cabinet Office",
    source: "Calendly · /gov", status: "Confirmed",
    prep: "Formal RFP just submitted. Bring credentials pack + FedRAMP-equivalent documentation.",
    agenda: ["Overview of RFP scope (10m)", "Team capabilities & security posture (20m)", "Delivery methodology (15m)", "Q&A (15m)"],
    history: 1, quality: 91,
  },
  {
    id: "m-4", when: "Tomorrow · 15:00", duration: "30 min", channel: "Google Meet",
    prospect: "Sarah Chen", role: "VP Engineering", company: "Kestrel Analytics",
    source: "Calendly · /pricing", status: "Confirmed",
    prep: "Renewal + upsell opportunity. Pitch phase-2 chatbot expansion.",
    agenda: ["Renewal outline (10m)", "Phase-2 scope (15m)", "Commercials (5m)"],
    history: 8, quality: 90,
  },
  {
    id: "m-5", when: "Fri · 11:00", duration: "45 min", channel: "Zoom",
    prospect: "Amelia Ortiz", role: "Design Director", company: "Pixel Foundry",
    source: "Website scheduling widget", status: "Awaiting confirmation",
    prep: "Fresh inbound from website. Show design-system audit sample.",
    agenda: ["Discovery (15m)", "Sample audit walkthrough (15m)", "Proposal outline (15m)"],
    history: 0, quality: 78,
  },
];

export const MEETING_TASKS = [
  { id: "t1", label: "Send follow-up recap to Naomi Park",        due: "Today · 18:00", done: false },
  { id: "t2", label: "Share architecture diagram with Marcus",    due: "Today · 19:00", done: false },
  { id: "t3", label: "Prepare RFP credentials pack for Corben",   due: "Tomorrow · 09:00", done: false },
  { id: "t4", label: "Draft renewal proposal for Kestrel",        due: "Wed · 17:00", done: true  },
];
